// extracted by mini-css-extract-plugin
export default {"container":"Groups_container__Q3760"};